import { constants } from 'helpers';

const DEFAULT_CONFIG = {
  button_custom_id: 'schedule-btn',
  widget_type: 'button',
  url: constants.EDUZZ_SIMPLYBOOK_URL,
  theme: 'space',
  theme_settings: {
    timeline_hide_unavailable: '1',
    sb_base_color: '#FFBC00',
    hide_past_days: '0',
    timeline_show_end_time: '0',
    timeline_modern_display: 'as_slots',
    display_item_mode: 'block',
    sb_review_image: '',
    dark_font_color: '#474747',
    light_font_color: '#ffffff',
    sb_company_label_color: '#ffffff',
    hide_img_mode: '0',
    show_sidebar: '1',
    sb_busy: '#B37700',
    sb_available: '#FFF3A3',
  },
  timeline: 'modern',
  datepicker: 'top_calendar',
  is_rtl: false,
  app_config: {
    clear_session: 0,
    allow_switch_to_ada: 0,
    predefined: {},
  },
  button_title: 'Book now',
  button_background_color: '#FFBC00',
  button_text_color: '#ffffff',
  button_position: 'right',
  button_position_offset: '55%',
};

export const getConfig = (walletId: number) => {
  const clone = JSON.parse(JSON.stringify(DEFAULT_CONFIG));
  clone.app_config.predefined.service = walletId;
  return clone;
};
